import { render, staticRenderFns } from "./CarouselLayout.vue?vue&type=template&id=42d06150&"
import script from "./CarouselLayout.vue?vue&type=script&lang=js&"
export * from "./CarouselLayout.vue?vue&type=script&lang=js&"
import style0 from "./CarouselLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports